export default "__VITE_ASSET__b14c0858__"